import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import classes from '../updater.module.css';
import fields from '../Field.constants';
import { email } from 'Common/Utils/regexPatterns';

function UpdateTextField({
    field,
    initialValue,
    onChange
}) {
    const [error, setError] = useState();
    const [value, setValue] = useState(initialValue);
    const inputType = field === fields.TeamEmail ? "email" : "text";
    const required = (field === fields.TeamEmail || field === fields.MarkingMethod);

    let maxLength = 0;
    switch (field) {
        case fields.TeamEmail:
            maxLength = 150;
            break;
        case fields.MarkingMethod:
            maxLength = 200;
            break;
        default:
            maxLength = 50;
    }

    const validate = useCallback(val => {
        let err = null;
        if ((!val || !val.length) &&  required) {
            err = 'Required';
        } else if (val.length > maxLength) {
            err = `Must not be longer than ${maxLength}`
        } else {
            err = field !== fields.TeamEmail || email.test(val) ? null : 'Must be a valid email address';
        }

        setError(err);
        return err === null;
    }, [field, required, maxLength, setError]);

    useEffect(() => {
        if (initialValue) {
            validate(initialValue);
        }
    }, [initialValue, validate]);

    return (
        <TextField
            id={`update-field__${field}`}
            label={field}
            inputProps={{ type: inputType, autoComplete: "off", maxLength, className: classes['form-input'] }}
            required={required}
            value={value || ''}
            error={!!error}
            helperText={error}
            onChange={handleValueChange}
        />
    );

    function handleValueChange(e) {
        const val = e.target.value;
        setValue(val);
        if (validate(val)) {
            onChange(val);
        } else {
            onChange(null);
        }
    }
}

UpdateTextField.propTypes = {
    field: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default UpdateTextField;
